

import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { DonutChart, BubbleChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

function MparBatterIssue() {
    const [isLoading, setIsLoading] = useState(true)
    const [title, setTitle] = useState("MMS Battery Issue Alerts")
    const [summary, setSummary] =  useState("File Collection Monitored Devices for Battery Issues. Please use the MPAR Battery Issue workbook for more info.")
    const [categories] = useState(["performance","battery"])
    const [data, setData] = useState(null)
	const [facilityLayout] = useState([
		{column:"Device Id", field:"deviceid"},
        {column:"Facility", field:"facilityname"},
        {column:"Customer Name", field: "customername"},
        {column:"Device Type",field:"devicetype"},
        {column:"Battery Issue Messages",field:"count"},
    ])
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        async function fetch() {
            await API.get('qs-web-api', '/data/mpar/batteryIssue.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>
				<Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="subText">
                        <Typography>
                            Displaying Battery messages from file collection for anesthesia and med station devices.
                            The message is either critically low or bad battery. The objective of the story is to help
                            explain where the issue batteries are in the field and give a sense of the overall trend.
							<p></p>
                            To meet quality standards batteries need to be replaced every two years, so the data
                            gives telemetry to catch potential issues. Additionally, monitoring the reliability will
                            prevent issues for customers. The overall initiative came to light after the terrible
                            power outage in March of 2021, as a way to stay proactive in maintenance.
                        </Typography>
                    </div>
                </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6" fontWeight="bold">
                            Overall Trend for Issue Batteries Across the MMS System
                    </Typography>
                    </div>
                </Grid>
                    <TableContainer className="dataTable">
                        <Table className="dataTable" aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="right">Device Type</TableCell>
                                    <TableCell align="right">Device Count</TableCell>
                                    <TableCell align="right">Unable to Monitor Devices</TableCell>
                                    <TableCell align="right">Number of Critical Errors</TableCell>
                                    <TableCell align="right">Number of Critical Devices</TableCell>
                                    <TableCell align="right">Number of Bad Battery Errors</TableCell>
                                    <TableCell align="right">Number of Bad Battery Devices</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.batterTable.map((row) => (
                                    <TableRow key={row.deviceid}>
                                        <TableCell component="th" scope="row">
                                            {row.devicetype}
                                        </TableCell>
                                        <TableCell align="right">{row.unique_devices}</TableCell>
                                        <TableCell align="right">{row.unavilable_devices}</TableCell>
                                        <TableCell align="right">{row.critical_errors}</TableCell>
                                        <TableCell align="right">{row.critical_devices}</TableCell>
                                        <TableCell align="right">{row.bad_errors}</TableCell>
                                        <TableCell align="right">{row.bad_battery_devices}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
				</Paper>

				<Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6" fontWeight="bold">
                            Bubble Chart Critical Low of Facility Device Count and Number of Issues by Avg Issues
                    </Typography>
                    </div>
                </Grid>
                 <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <BubbleChart data={data.patchGuidanceBubble_cl.data} scale={data.patchGuidanceBubble_cl.scale} colors={color.defaultScheme} tooltip={"Avg Number of Issues for <br> is: "} width={750} height={550}></BubbleChart>
                </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            Top 10 Devices with Critically Low Battery Message
                    </Typography>
                    </div>
                </Grid>
                    <StoryTable data={data.critTable} layout={facilityLayout}></StoryTable>

				</Paper>
				<Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6" fontWeight="bold">
                            Bubble Chart for Bad Batteries of Facility Device Count and Number of Issues by Avg Issues
                    </Typography>
                    </div>
                </Grid>
                 <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <BubbleChart data={data.patchGuidanceBubble_bb.data} scale={data.patchGuidanceBubble_bb.scale} colors={color.defaultScheme} tooltip={"Avg Number of Issues for <br> is: "} width={750} height={550}></BubbleChart>
                </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            Top 10 Devices with Bad Battery Message
                    </Typography>
                    </div>
                </Grid>
                    <StoryTable data={data.badTable} layout={facilityLayout}></StoryTable>

				</Paper>

            </div >
        )
    }
}

export default MparBatterIssue